import classNames from 'classnames';

import { FAIcon } from '../adapters/fontAwesomeAdapters';
import { InlineLink } from '../typography';
import { MapCard } from './MapCard';
import { useCollapsibleMapCardStyles } from './CollapsibleMapCard.styles';

export function CollapsibleMapCard({
  className,
  beforeContent,
  expanded,
  children,
}) {
  const { styles } = useCollapsibleMapCardStyles();
  return (
    <MapCard
      className={classNames(styles.collapsibleMapCard, { expanded }, className)}
    >
      {beforeContent}
      <div
        className={classNames(styles.collapseContent, { hidden: !expanded })}
      >
        {children}
      </div>
    </MapCard>
  );
}

export function CollapsibleMapCardWithToggle({
  expanded,
  setExpanded,
  className,
  children,
}) {
  const { styles } = useCollapsibleMapCardStyles();
  return (
    <CollapsibleMapCard
      className={className}
      expanded={expanded}
      beforeContent={
        <InlineLink
          className={styles.collapseControl}
          textId="labels.map"
          iconBefore={
            <FAIcon
              icon={expanded ? 'angle-up' : 'angle-down'}
              className="icon-20"
            />
          }
          onClick={() => setExpanded(!expanded)}
        />
      }
    >
      {children}
    </CollapsibleMapCard>
  );
}
